export const StompConfig = {
  brokerURL: 'ws://localhost:8090/api/notification',
  heartbeatIncoming: 0,
  heartbeatOutgoing: 20000,
  reconnectDelay: 20000,
};
